import { Service } from '@/request/http.js'

// 数据看板
export function dashBoard (data) {
  return Service({
    url: '/api/dashboard',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/dashboard.js